import { createContext, useContext } from 'react';

import noop from 'utils/noop';
import { RestQueryHookResult } from 'utils/hooks/api/useRestQuery';
import { ProfileQuery } from '../../domain';

type ProfileRefetch = RestQueryHookResult<ProfileQuery>['refetch'];

export type ProfileQueryState = ProfileQuery & {
  profileError: unknown;
  isProfileError: boolean;
  isProfileLoading: boolean;
  profile: ProfileQuery;
  refetchProfile: ProfileRefetch;
};

export const profileQueryDefaultState = {
  emailDomains: [],
  brandAffinityLevels: [],
  devices: [],
  locations: [],
  isProfileError: false,
  profileError: null,
  isProfileLoading: false,
  profile: {},
  refetchProfile: noop as ProfileRefetch,
};

export const ProfileQueryContext = createContext<ProfileQueryState>(profileQueryDefaultState);

export const useProfileQueryContext = () => useContext(ProfileQueryContext);
